var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { PICAction, PICBase, customElement, objectDecoder } from '../Internals';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { isSvgTextMonochrome } from '../../util/SvgColor';
let PICSVG = class PICSVG extends PICBase {
    constructor() {
        super(...arguments);
        // Is the fetched SVG grayscale/monochrome. Only relevant when `color` isn't explicitly set
        // (the default fill is black, which is invisible against a dark page background) - an
        // explicit `color` is a deliberate caller choice and is never auto-adjusted.
        this.isMonoSvg_ = false;
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --SVGFillColor: 'black';
        }

        svg {
            width: 100%;
            height: 100%;
        }

        svg, svg g, svg g path{
            fill: var(--SVGFillColor) !important;
        }

        .outerContainer.clickable:hover{
            cursor: pointer;
        }

        /* See isMonoSvg_ above. Compresses the tonal range toward mid-gray so the default
           black fill doesn't disappear against a dark page background. Inert in light mode -
           --pic-imageMonoContrast is only defined under [data-theme="dark"] in webtoolbox.css. */
        .outerContainer.mono-svg {
            filter: contrast(var(--pic-imageMonoContrast, 1));
        }

        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    focus() {
    }
    validateSubmit() {
        return true;
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchSVG();
    }
    fetchSVG() {
        if (this.src) {
            fetch(this.src)
                .then(response => {
                if (response.ok) {
                    return response.text();
                }
                else
                    throw new Error('fetch SVG has failed');
            })
                .then(rawSVGData => {
                this.isMonoSvg_ = isSvgTextMonochrome(rawSVGData);
                if (rawSVGData.startsWith('<?xml version'))
                    this.svgData = rawSVGData.split('\n').slice(1).join('\n');
                else
                    this.svgData = rawSVGData;
                this.requestUpdate();
            })
                .catch(err => {
                console.log(err);
            });
        }
    }
    getOuterContainerClass() {
        return {
            outerContainer: true,
            clickable: this.clickAction ? true : false,
            'mono-svg': !this.color && this.isMonoSvg_
        };
    }
    getOuterContainerStyle() {
        return {
            width: this.width,
            height: this.height
        };
    }
    handleClick(e) {
        if (this.clickAction) {
            try {
                let myAction = new PICAction();
                myAction.actionOptions = this.clickAction;
                myAction.triggerEvent(e);
            }
            catch (_a) {
                console.log('invalid action:', this.clickAction);
            }
        }
    }
    render() {
        var _a;
        this.style.setProperty('--SVGFillColor', (_a = this.color) !== null && _a !== void 0 ? _a : 'black');
        if (!this.svgData && this.src)
            this.fetchSVG();
        return html `
            <div class=${classMap(this.getOuterContainerClass())} @click=${this.handleClick} style=${styleMap(this.getOuterContainerStyle())}>
                ${this.svgData ? unsafeHTML(this.svgData) : nothing}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : nothing}
            `;
    }
};
__decorate([
    property()
], PICSVG.prototype, "src", void 0);
__decorate([
    property()
], PICSVG.prototype, "width", void 0);
__decorate([
    property()
], PICSVG.prototype, "height", void 0);
__decorate([
    property()
], PICSVG.prototype, "color", void 0);
__decorate([
    property({ converter: objectDecoder })
], PICSVG.prototype, "clickAction", void 0);
PICSVG = __decorate([
    customElement('pic-svg')
], PICSVG);
export { PICSVG };
//# sourceMappingURL=PICSVG.js.map